<template>
	<section class="form-section">
		<header>Документы</header>

    <ul>
      <li
        v-for="contract in actualContracts"
        :key="contract.id"
        style="margin-bottom: 5px;"
      >
        <router-link
          :to="`/list/contracts-public/${contract.type.id}/${contract.version}`"
          target="_blank"
        >
          <VIcon
            material="description"
            theme="outlined"
          />
          {{ contract.type.name }}
        </router-link>
      </li>
    </ul>
	</section>
</template>


<script lang="ts">
import type ContractPublic from "@/domains/Contracts/ContractPublic";
import ContractsPublicService from "@/domains/Contracts/ContractsPublicService";

export default defineComponent({
	props: {},

  data() {
    return {
      actualContracts: [] as ContractPublic[]
    }
  },

  async created() {
    this.actualContracts = await ContractsPublicService.getList({isActual: true})
  },

	computed: {},

});
</script>
